module.exports = __webpack_public_path__ + "static/media/33pic.d96de955.jpg";